import FaqsGenerator from '@/features/faqs-generator';

function FaqsPage() {
  return <FaqsGenerator />;
}

export default FaqsPage;

